import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(_error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null
    });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#FBF9F3] flex items-center justify-center p-4">
          <div className="brand-card max-w-2xl w-full">
            <Alert className="border-red-200 bg-red-50">
              <AlertCircle className="h-5 w-5 text-red-600" />
              <AlertTitle className="text-red-900 text-lg font-semibold mb-2">
                Algo salió mal
              </AlertTitle>
              <AlertDescription className="text-red-800 space-y-4">
                <p>
                  La aplicación encontró un error inesperado. Por favor, intenta recargar la página.
                </p>

                {process.env.NODE_ENV === 'development' && this.state.error && (
                  <div className="mt-4 p-4 bg-white rounded border border-red-200">
                    <p className="font-mono text-xs text-red-900 whitespace-pre-wrap">
                      {this.state.error.toString()}
                    </p>
                    {this.state.errorInfo && (
                      <details className="mt-2">
                        <summary className="cursor-pointer text-sm font-medium text-red-800">
                          Stack trace
                        </summary>
                        <pre className="mt-2 text-xs text-red-900 overflow-auto max-h-64">
                          {this.state.errorInfo.componentStack}
                        </pre>
                      </details>
                    )}
                  </div>
                )}

                <div className="flex gap-2 mt-6">
                  <Button
                    onClick={() => window.location.reload()}
                    style={{
                      background: 'linear-gradient(145deg, #FFD33B, #C6A136)',
                      color: '#4B2E14'
                    }}
                  >
                    <RefreshCw className="w-4 h-4 mr-2" />
                    Recargar Página
                  </Button>
                  <Button
                    onClick={this.handleReset}
                    variant="outline"
                  >
                    Intentar de Nuevo
                  </Button>
                </div>
              </AlertDescription>
            </Alert>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
